import React, { useState } from 'react';
import styled from 'styled-components';
import Icon from '../../../../../../common/Icon';
import { SubtitleThree } from '../../../../../../styles/theme/default/typography';
import Value from '../../valueProposition/Value';
import { valuesPropsToShow } from '../../valueProposition/ValueProposition';

const Wrapper = styled.div`
  cursor: pointer;
  padding: 20px;
  border-top: 1px solid #d8d8d8;

  .title-open-btn {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .content-container {
    margin-top: 30px;

    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-gap: 16px;
  }
`;

function ValueProposition({ productData, className, openByDefault }) {
  const [open, setOpen] = useState(openByDefault);

  const categoryId = productData?.frame?.subcategories[0]?.category.id;
  const assemblyAvailable = productData?.frame?.shippingServices.some(
    x => parseInt(x.id) === 1
  );

  const isWarranty = productData?.warranty;

  const valueProps = valuesPropsToShow(
    categoryId,
    assemblyAvailable,
    isWarranty,
    productData
  );

  return (
    <Wrapper className={className ? className : ''}>
      <div className="title-open-btn" onClick={() => setOpen(!open)}>
        <SubtitleThree bold={true}>Why You’ll Love It</SubtitleThree>
        <Icon
          icon={`ti-arrow-${open ? 'up' : 'down'}`}
          size={12}
          color="black"
        />
      </div>
      {open && (
        <div className="content-container">
          {valueProps.map((valueProp, i) => (
            <Value key={i} valueProp={valueProp} className="value-prop" />
          ))}
        </div>
      )}
    </Wrapper>
  );
}

export default ValueProposition;
